/* eslint-disable react/no-danger */
import React from 'react';

import { Typo } from 'uikit/content';

import getSanitizedDescription from '../helpers/getSanitizedDescription';

import styles from '../styles/versioningComposeDescription.module.scss';

const VersioningComposeDescription = ({
  value,
}) => (
    <Typo className={styles.element} variant="b03" element="div">
      <p 
        dangerouslySetInnerHTML={{
          __html: getSanitizedDescription({ html: value }),
        }} 
      />
    </Typo>
  )

export default React.memo(VersioningComposeDescription);
